import { render } from "./KeyVote.vue?vue&type=template&id=a4f5928c"
import script from "./KeyVote.vue?vue&type=script&lang=js"
export * from "./KeyVote.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Song\\Documents\\Fun\\snapshot\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__